<form [formGroup]="headerFormGroup">
<div class="form-horizontal">

    <div class="modal-header">
        <div class="title col-11">
            <div class="row col-12">
                <h2 class="modal-title-prefix"><span translate="VRSTASTAVKI.SINGULAR"></span></h2>
            </div>
            <!-- <h2 class="modal-title"> -->
                <div class="form-group row col-12">
                    <div class="col-9">
                        <h1>
                            <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="VRSTASTAVKI.NEW"></span></span>
                            <span *ngIf="baseUpdate.Item.ID > 0"><span>{{baseUpdate.Item.Naziv}}</span></span>
                        </h1>
                    </div>
                    <div class="col-3">
                        <span *ngIf="baseUpdate.Item.ID > 0">
                            <yt-dropdown-picklist
                            [ModelName]="'language'"
                            [GetName]="'get'"
                            [ModelProperty]="'Name'"
                            formControlName="JezikID"
                            [Position]="'right'"
                            [AllowAddNew]="false"
                            (OnItemSelected)="onJezikSelect($event)"                            
                        >
                        </yt-dropdown-picklist>
                        </span>
                    </div>
                </div>
            <!-- </h2> -->
        </div>
        <span class="close col-1" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
    </div>
    <div class="modal-body">
        <yt-vrsta-stavki-update #baseUpdate></yt-vrsta-stavki-update>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="Save()"><span>Sačuvaj</span></button>
        <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
    </div>
</div>

</form>